import { FC, useState } from "react";
import LoadingButton from "../../atom/Button/LoadingButton/LoadingButton";
import { handleFileDownload } from "../../../helpers/handleFileDownload";

interface FileDownloadProps {
  file: File | null | undefined;
  url?: string;
  buttonName: string;
}

const FileDownload: FC<FileDownloadProps> = ({
  file,
  url = "",
  buttonName,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const onDownload = () => {
    if (file) {
      setIsLoading(true);
      handleFileDownload(file, url);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  return (
    <LoadingButton
      isLoading={isLoading}
      variant="secondary"
      onClick={onDownload}
      isButtonDisabled={!file}
    >
      {buttonName}
    </LoadingButton>
  );
};

export default FileDownload;
